import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTopbar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutTopbar"><Path d="M3 9V3H21V9L3 9Z" fill="currentColor"/><Path d="M3 11V21L11 21L11 11H3Z" fill="currentColor"/><Path d="M13 21L21 21V11L13 11L13 21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutTopbar;
